import script from "./CopyDetailsSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyDetailsSettings.vue?vue&type=script&setup=true&lang=ts"

import "./CopyDetailsSettings.vue?vue&type=style&index=0&id=ff84648a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff84648a"]])

export default __exports__